import { type SanityImageSource } from '@sanity/image-url'
import { fileUrlFor, imageUrlFor } from '#app/utils/cms.ts'

export interface LocalizedContent {
  _key?: string
  en: string
  es: string
}

interface FileContent {
  asset: {
    _ref: string
  }
}

export interface LocalizedFileContent {
  en: FileContent
  es: FileContent
}

export interface LocalizedImageContent {
  en: SanityImageSource
  es: SanityImageSource
}

const defaultLocale = 'en'

export const getLocalizedContent = (
  content: LocalizedContent | null | undefined,
  locale: string,
) => {
  if (!content) {
    return undefined
  }

  if (locale in content) {
    const supportedLocale = locale as keyof LocalizedContent
    return content[supportedLocale]
  }

  return content[defaultLocale]
}

export const getLocalizedFileUrl = (
  content: LocalizedFileContent,
  locale: string,
) => {
  let localizedFileContent = content[defaultLocale]

  if (locale in content) {
    const supportedLocale = locale as keyof LocalizedFileContent
    localizedFileContent = content[supportedLocale]
  }

  return fileUrlFor(localizedFileContent.asset)
}

export const getLocalizedImageUrl = (
  content: LocalizedImageContent,
  locale: string,
) => {
  if (!content) return ''

  let localizedImageContent = content[defaultLocale]

  if (locale in content) {
    const supportedLocale = locale as keyof LocalizedFileContent
    localizedImageContent = content[supportedLocale]
  }

  if (!localizedImageContent) return ''

  return imageUrlFor(localizedImageContent).toString()
}
